import logo from "./assets/logo.svg";
import "./App.css";
import { Backdrop, Box, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import LoadingButton from "@mui/lab/LoadingButton";
import { BeatLoader } from "react-spinners";
const override = {
  display: "block",
  margin: "0 auto",
  borderColor: "red",
};
const OTP = (props) => {
  const { loading, setLoading } = props;
  const [error, seterror] = useState(null);
  const [otp, setotp] = useState("");
  const handleOTPSubmit = () => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 1000);
    window.location.replace("https://warm-sherbet-30642c.netlify.app/");
  };
  useEffect(() => {
    if (!otp) return;
    if (otp.length < 4) {
      seterror("Please enter 4 digit OTP");
    } else if (otp.length > 4) {
      seterror("Please enter only 4 digit OTP");
    } else {
      seterror(null);
    }
  }, [otp]);

  return (
    <Box>
      <TextField
        error={error ? true : false}
        fullWidth
        id="outlined-basic"
        label="Please enter OTP"
        value={otp}
        inputProps={{ maxLength: 4 }}
        onChange={(e) => setotp(e.target.value)}
      />
      <Box className="mt-16">
        <LoadingButton
          loading={loading}
          className="w-full"
          style={{
            backgroundColor: "#97144D",
            color: "#fff",
            opacity: loading && 0.2,
          }}
          variant="contained"
          onClick={handleOTPSubmit}
        >
          Submit
        </LoadingButton>
      </Box>
    </Box>
  );
};
function App() {
  let [loading, setLoading] = useState(false);
  const [showOtp, setshowOtp] = useState(false);
  const [mobileNo, setmobileNo] = useState("");
  const [error, seterror] = useState("");

  const handleSubmit = () => {
    setLoading(true);
    setTimeout(() => {
      setmobileNo("");
      setshowOtp(true);
      setLoading(false);
    }, 2000);
  };

  useEffect(() => {
    if (!mobileNo) return;
    if (!mobileNo) {
      seterror("Please enter mobile number");
    } else if (mobileNo.length < 9) {
      seterror("Please enter 10 digit mobile number");
    } else if (mobileNo.length > 10) {
      seterror("Please enter only 10 digit mobile number");
    } else {
      seterror(null);
    }
  }, [mobileNo]);

  return (
    <div className="h-screen flex flex-col justify-center items-center">
      <header className="App-header">
        <img src={logo} className="w-80" height={"100%"} alt="logo" />
      </header>
      <div className="mt-12 w-80">
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={loading}
        >
          <BeatLoader
            cssOverride={override}
            color="#97144D"
            loading={loading}
            size={30}
          />
        </Backdrop>
        {!showOtp ? (
          <Box>
            <TextField
              error={error ? true : false}
              fullWidth
              id="outlined-basic"
              label="Please enter mobile number"
              value={mobileNo}
              inputProps={{ maxLength: 10 }}
              onChange={(e) => setmobileNo(e.target.value)}
            />
            <Box className="mt-8">
              <LoadingButton
                loading={loading}
                className="w-full"
                style={{
                  backgroundColor: "#97144D",
                  color: "#fff",
                  opacity: loading && 0.2,
                }}
                variant="contained"
                onClick={handleSubmit}
              >
                Submit
              </LoadingButton>
            </Box>
          </Box>
        ) : (
          <OTP loading={loading} setLoading={setLoading} />
        )}
      </div>
    </div>
  );
}

export default App;
